import type { PreTradeAnalytic } from '../../../redux/preTradeApiTypes';

function parseFiniteNumber(value: string | undefined): number | null {
  if (value == null) {
    return null;
  }

  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function getAnalyticValue(analytics: PreTradeAnalytic[], property: string, market?: string): string | undefined {
  return analytics.find(analytic => {
    if (analytic.Property !== property) {
      return false;
    }
    if (market != null) {
      return analytic.Market === market;
    }
    return analytic.Market == null;
  })?.Value;
}

/**
 * Returns a parsed numeric analytic value for the given property/market.
 * Returns `undefined` when analytics are missing, the property is not found, or the value is non-finite.
 */
export function getNumeric(
  analytics: PreTradeAnalytic[] | undefined,
  property: string,
  market?: string
): number | undefined {
  const value = analytics ? getAnalyticValue(analytics, property, market) : undefined;
  const parsed = parseFiniteNumber(value);
  return parsed == null ? undefined : parsed;
}

/** Converts fractional values (for example `0.15`) into percentage numbers (`15`). */
export function toPercentNumber(value?: number): number | undefined {
  return value != null ? value * 100 : undefined;
}
